/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { Link, Stack, mergeStyles } from '@bingads-webui-react/fabric-control';
import classNames from 'classnames';
import { Header, DefaultButton, PrimaryButton, DaysRemaining } from './components';
import { getDaysToExpiration } from './utils';

const descriptionStyles = mergeStyles({
  minHeight: 60,
  marginTop: 16,
  marginBottom: 12,
});

const confirmationButtonStyles = mergeStyles({
  marginRight: 8,
});

export const RemindLater = ({
  coupon, onNotInterested, onActivate, onConfirm, onDismiss, i18n,
}) => {
  const diffDays = useMemo(() => getDaysToExpiration(coupon.expirationDate), [coupon.expirationDate]);

  return (
    <div>
      <Header text={i18n.getString('RemindLater_Title')} i18n={i18n} onCloseButtonClick={onDismiss} />
      <div className={classNames('coupon-description', descriptionStyles)}>
        <DaysRemaining i18n={i18n} diffDays={diffDays} />
        {' '}
        {i18n.getString('RemindLater_Description_ActivationMessage_1')}
        {' '}
        <Link onClick={onActivate}>{i18n.getString('RemindLater_Description_ActivationMessageLink')}</Link>
        {' '}
        {i18n.getString('RemindLater_Description_ActivationMessage_2')}
      </div>
      <Stack horizontal horizontalAlign="space-between" verticalAlign="center">
        <DefaultButton text={i18n.getString('Button_NotInterested')} onClick={onNotInterested} className="close-button" />
        <Stack horizontal horizontalAlign="end" verticalAlign="center">
          <PrimaryButton text={i18n.getString('Button_Confirmation')} onClick={onConfirm} className={classNames(confirmationButtonStyles, 'confirmation-button')} />
          <DefaultButton text={i18n.getString('Button_Close')} onClick={onDismiss} className="close-button" />
        </Stack>
      </Stack>
    </div>);
};

RemindLater.propTypes = {
  coupon: PropTypes.shape({
    expirationDate: PropTypes.string,
  }).isRequired,
  i18n: PropTypes.shape({
    getString: PropTypes.func,
  }).isRequired,
  onActivate: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
  onDismiss: PropTypes.func.isRequired,
  onNotInterested: PropTypes.func.isRequired,
};
